<template>
  <div>
    <vx-card class="scroll-content" title="Employee Lists">
      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <template>
            <vs-table
              stripe
              v-model="selected"
              max-items="8"
              pagination
              search
              :data="getAllEmployees"
            >
              <template slot="thead">
                <vs-th width="20px"></vs-th>
                <vs-th>Code</vs-th>
                <vs-th>Last Name</vs-th>
                <vs-th>First Name</vs-th>
                <vs-th>Middle Name</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].photoUrl">
                    <div v-if="data[indextr].photoUrl != ''">
                      <vs-avatar
                        :src="data[indextr].photoUrl"
                        class="flex-shrink-0 mr-2"
                        size="30px"
                      />
                    </div>
                    <div v-else>
                      <vs-avatar
                        class="rounded-full shadow-md cursor-pointer block"
                        size="40"
                        :text="data[indextr].fullName"
                        :color="
                          data[indextr].fullName.length < 12
                            ? 'success'
                            : data[indextr].fullName.length <= 15
                            ? 'primary'
                            : data[indextr].fullName.length <= 20
                            ? 'warning'
                            : 'danger'
                        "
                      />
                    </div>
                  </vs-td>
                  <vs-td :data="data[indextr].employeeCode">
                    {{ data[indextr].employeeCode }}
                  </vs-td>
                  <vs-td :data="data[indextr].lastName">
                    {{ data[indextr].lastName }}
                  </vs-td>
                  <vs-td :data="data[indextr].firstName">
                    {{ data[indextr].firstName }}
                  </vs-td>
                  <vs-td :data="data[indextr].middleName">
                    {{ data[indextr].middleName }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </template>
        </div>
      </div>
    </vx-card>

    <div
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        margin-top: 1%;
      "
    >
      <vx-card
        title="Employment Details"
        class="employment-details-card"
        style="margin: 0 auto"
      >
        <div class="vx-row" style="text-align: center; display: flex">
          <vs-button
            type="gradient"
            color="primary"
            @click="promptAddNewRecord()"
            icon-pack="feather"
            icon="icon-plus"
            style="padding: 8px 20px; margin-right: 20px; margin-left: 15px"
          >
            Add
          </vs-button>

          <vs-button
            type="gradient"
            color="danger"
            @click="confirmDeleteRecord(selectedYearData.id)"
            icon-pack="feather"
            icon="icon-trash"
            style="padding: 8px 20px; margin-right: 20px; margin-left: 15px"
          >
            Delete
          </vs-button>

          <vs-button
            type="gradient"
            color="primary"
            @click="isEdit ? saveData() : editData()"
            icon-pack="feather"
            :icon="isEdit ? 'icon-save' : 'icon-edit'"
            class="mr-base"
            style="padding: 8px 20px"
          >
            {{ isEdit ? "Save" : "Edit" }}
          </vs-button>

          <vs-button
            v-if="isEdit"
            type="gradient"
            color="danger"
            @click="cancelEdit()"
            icon-pack="feather"
            icon="icon-x-circle"
            class="ml-base"
            style="padding: 8px 20px"
          >
            Cancel
          </vs-button>
        </div>
        <!-- Year Selection -->
        <div class="vx-row row-year" style="text-align: center">
          <div
            class="vx-col md:w-1/2 year_div"
            style="margin: 0 auto; margin-bottom: 20px"
          >
            <span class="text-sm">Year</span>
            <v-select
              v-if="!isEdit"
              v-validate="'required'"
              class="w-full"
              name="year"
              v-model="Company.yearScope"
              :options="yearOptions"
              placeholder="Please Select"
              @input="SelectedYearandData"
            />
            <input
              v-else
              type="text"
              v-model="Company.yearScope"
              class="w-full"
              placeholder="Year"
            />
          </div>
        </div>

        <template>
          <div>
            <vs-table :data="[selectedYearData]" class="Company-table">
              <template slot="thead">
                <vs-th>Company</vs-th>
                <vs-th>Address</vs-th>
                <vs-th>TIN</vs-th>
                <vs-th>Zip Code</vs-th>
              </template>
              <vs-tr v-if="selectedYearData">
                <vs-td>
                  <span v-if="!isEdit">{{ selectedYearData.companyName }}</span>
                  <vs-input
                    v-else
                    v-model="Company.companyName"
                    placeholder="Company Name"
                  />
                </vs-td>
                <vs-td>
                  <span v-if="!isEdit">{{
                    selectedYearData.companyAddress
                  }}</span>
                  <vs-input
                    v-else
                    v-model="Company.companyAddress"
                    placeholder="Company Address"
                  />
                </vs-td>
                <vs-td>
                  <span v-if="!isEdit">{{ selectedYearData.companyTIN }}</span>
                  <vs-input
                    v-else
                    v-model="Company.companyTIN"
                    placeholder="Company TIN"
                  />
                </vs-td>
                <vs-td>
                  <span v-if="!isEdit">{{
                    selectedYearData.companyZipCode
                  }}</span>
                  <vs-input
                    v-else
                    v-model="Company.companyZipCode"
                    placeholder="Company Zip Code"
                  />
                </vs-td>
              </vs-tr>
              <vs-tr v-else>
                <vs-td colspan="4">
                  <span v-if="!isEdit">No data available</span>
                  <template v-else>
                    <vs-td>
                      <vs-input
                        v-model="Company.companyName"
                        placeholder="Company Name"
                      />
                    </vs-td>
                    <vs-td>
                      <vs-input
                        v-model="Company.companyAddress"
                        placeholder="Company Address"
                      />
                    </vs-td>
                    <vs-td>
                      <vs-input
                        v-model="Company.companyTIN"
                        placeholder="Company TIN"
                      />
                    </vs-td>
                    <vs-td>
                      <vs-input
                        v-model="Company.companyZipCode"
                        placeholder="Company Zip Code"
                      />
                    </vs-td>
                  </template>
                </vs-td>
              </vs-tr>
            </vs-table>
          </div>

          <div class="vx-row" style="display: flex; justify-content: center">
            <!-- Present Employer -->
            <div
              class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base"
              style="margin-bottom: 20px"
            >
              <vx-card title="Present Employer" class="employer-card">
                <div class="field-group" v-if="selectedYearData">
                  <div class="field">
                    <label>Gross Pay</label>
                    <input
                      v-if="!isEdit"
                      type="number"
                      readonly
                      v-model="selectedYearData.ytdGrossPay"
                    />
                    <input v-else type="number" v-model="Company.ytdGrossPay" />
                  </div>

                  <div class="field">
                    <label>Basic Pay</label>
                    <input
                      v-if="!isEdit"
                      type="number"
                      readonly
                      v-model="selectedYearData.ytdBasicPay"
                    />
                    <input v-else type="number" v-model="Company.ytdBasicPay" />
                  </div>

                  <div class="field">
                    <label>Whtax</label>
                    <input
                      v-if="!isEdit"
                      type="number"
                      pattern="\d*"
                      readonly
                      v-model="selectedYearData.ytdwhTax"
                    />
                    <input v-else type="number" v-model="Company.ytdwhTax" />
                  </div>

                  <div class="field">
                    <label>Taxable Bonus</label>
                    <input
                      v-if="!isEdit"
                      type="number"
                      readonly
                      v-model="selectedYearData.ytdTaxableBonus"
                    />
                    <input
                      v-else
                      type="number"
                      v-model="Company.ytdTaxableBonus"
                    />
                  </div>

                  <div class="field">
                    <label>NonTax Bonus</label>
                    <input
                      v-if="!isEdit"
                      type="number"
                      readonly
                      v-model="selectedYearData.ytdNonTaxableBonus"
                    />
                    <input
                      v-else
                      type="number"
                      v-model="Company.ytdNonTaxableBonus"
                    />
                  </div>

                  <div class="field">
                    <label>Taxable Earnings</label>
                    <input
                      v-if="!isEdit"
                      type="number"
                      readonly
                      v-model="selectedYearData.ytdTaxableEarnings"
                    />
                    <input
                      v-else
                      type="number"
                      v-model="Company.ytdTaxableEarnings"
                    />
                  </div>

                  <div class="field">
                    <label>Non Taxable Earnings</label>
                    <input
                      v-if="!isEdit"
                      type="number"
                      readonly
                      v-model="selectedYearData.ytdNonTaxableEarnings"
                    />
                    <input
                      v-else
                      type="number"
                      v-model="Company.ytdNonTaxableEarnings"
                    />
                  </div>

                  <div class="field">
                    <label>Taxable Premium</label>
                    <input
                      v-if="!isEdit"
                      type="number"
                      readonly
                      v-model="selectedYearData.ytdTaxablePremium"
                    />
                    <input
                      v-else
                      type="number"
                      v-model="Company.ytdTaxablePremium"
                    />
                  </div>

                  <div class="field">
                    <label>Non Taxable Premium</label>
                    <input
                      v-if="!isEdit"
                      type="number"
                      readonly
                      v-model="selectedYearData.ytdNonTaxablePremium"
                    />
                    <input
                      v-else
                      type="number"
                      v-model="Company.ytdNonTaxablePremium"
                    />
                  </div>
                </div>
                <span v-else>No data available</span>
              </vx-card>
            </div>

            <!-- Previous Employer -->
            <div
              class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base"
              style="margin-bottom: 20px"
            >
              <vx-card title="Previous Employer" class="employer-card">
                <div class="field-group" v-if="selectedYearData">
                  <div class="field">
                    <label>Gross Pay</label>
                    <input
                      v-if="!isEdit"
                      type="number"
                      readonly
                      v-model="selectedYearData.prevYTDGrossPay"
                    />
                    <input
                      v-else
                      type="number"
                      v-model="Company.prevYTDGrossPay"
                    />
                  </div>

                  <div class="field">
                    <label>Basic Pay</label>
                    <input
                      v-if="!isEdit"
                      type="number"
                      readonly
                      v-model="selectedYearData.prevYTDBasicPay"
                    />
                    <input
                      v-else
                      type="number"
                      v-model="Company.prevYTDBasicPay"
                    />
                  </div>

                  <div class="field">
                    <label>Whtax</label>
                    <input
                      v-if="!isEdit"
                      type="number"
                      pattern="\d*"
                      readonly
                      v-model="selectedYearData.prevYTDWHTax"
                    />
                    <input
                      v-else
                      type="number"
                      v-model="Company.prevYTDWHTax"
                    />
                  </div>

                  <div class="field">
                    <label>Taxable Bonus</label>
                    <input
                      v-if="!isEdit"
                      type="number"
                      readonly
                      v-model="selectedYearData.prevYTDTaxableBonus"
                    />
                    <input
                      v-else
                      type="number"
                      v-model="Company.prevYTDTaxableBonus"
                    />
                  </div>

                  <div class="field">
                    <label>NonTax Bonus</label>
                    <input
                      v-if="!isEdit"
                      type="number"
                      readonly
                      v-model="selectedYearData.prevYTDNonTaxableBonus"
                    />
                    <input
                      v-else
                      type="number"
                      v-model="Company.prevYTDNonTaxableBonus"
                    />
                  </div>

                  <div class="field">
                    <label>Taxable Earnings</label>
                    <input
                      v-if="!isEdit"
                      type="number"
                      readonly
                      v-model="selectedYearData.prevYTDTaxableEarnings"
                    />
                    <input
                      v-else
                      type="number"
                      v-model="Company.prevYTDTaxableEarnings"
                    />
                  </div>

                  <div class="field">
                    <label>Non Taxable Earnings</label>
                    <input
                      v-if="!isEdit"
                      type="number"
                      readonly
                      v-model="selectedYearData.prevYTDNonTaxableEarnings"
                    />
                    <input
                      v-else
                      type="number"
                      v-model="Company.prevYTDNonTaxableEarnings"
                    />
                  </div>

                  <div class="field">
                    <label>Taxable Premiums</label>
                    <input
                      v-if="!isEdit"
                      type="number"
                      readonly
                      v-model="selectedYearData.prevYTDTaxablePremium"
                    />
                    <input
                      v-else
                      type="number"
                      v-model="Company.prevYTDTaxablePremium"
                    />
                  </div>

                  <div class="field">
                    <label>Non Taxable Premiums</label>
                    <input
                      v-if="!isEdit"
                      type="number"
                      readonly
                      v-model="selectedYearData.prevYTDNonTaxablePremium"
                    />
                    <input
                      v-else
                      type="number"
                      v-model="Company.prevYTDNonTaxablePremium"
                    />
                  </div>
                </div>
                <span v-else>No data available</span>
              </vx-card>
            </div>
          </div>
        </template>

        <div
          class="compute-button"
          style="text-align: center; margin-top: 20px"
        >
          <vs-button class="button" style="width: 200px"
            >Compute Tax Due</vs-button
          >
        </div>
      </vx-card>
    </div>
    <vs-prompt
      class="email-compose"
      title="Add YTD Details"
      accept-text="Submit"
      @accept="onAddNewRecord"
      :is-valid="validForm"
      :active.sync="activePromptAddRecord"
    >
      <vx-card title="Please fill-out the following information">
        <div class="vx-row mb-3 max-h-[55vh] overflow-y-auto">
          <div class="vx-col w-full mb-2">
            <span class="text-sm input-title"
              >User <span class="text-red-500">*</span></span
            >
            <v-select
              :options="getAllEmployees"
              label="fullName"
              v-model="selectedEmployee"
              v-validate="'required'"
              name="User"
              class="w-full"
              placeholder="Select a user"
              @input="handleEmployeeSelection"
            />
            <span class="text-red-500 text-sm" v-show="errors.has('User')">
              {{ errors.first("User") }}
            </span>
          </div>
          <div class="vx-col w-full mb-2">
            <span class="text-sm input-title"
              >Year <span class="text-red-500">*</span></span
            >
            <vs-input
              name="Year"
              type="number"
              v-validate="'required'"
              class="w-full"
              v-model="Company.yearScope"
            />
            <span class="text-red-500 text-sm" v-show="errors.has('Year')">
              {{ errors.first("Year") }}
            </span>
          </div>
          <div class="vx-col w-full mb-2">
            <span class="text-sm input-title"
              >Company Name <span class="text-red-500">*</span></span
            >
            <vs-input
              name="CompanyName"
              v-validate="'required'"
              class="w-full"
              v-model="Company.companyName"
            />
            <span
              class="text-red-500 text-sm"
              v-show="errors.has('CompanyName')"
            >
              {{ errors.first("CompanyName") }}
            </span>
          </div>
          <div class="vx-col w-full mb-2">
            <span class="text-sm input-title"
              >Company Address <span class="text-red-500">*</span></span
            >
            <vs-input
              name="CompanyAddress"
              v-validate="'required'"
              class="w-full"
              v-model="Company.companyAddress"
            />
            <span
              class="text-red-500 text-sm"
              v-show="errors.has('CompanyAddress')"
            >
              {{ errors.first("CompanyAddress") }}
            </span>
          </div>
          <div class="vx-col w-full mb-2">
            <span class="text-sm input-title"
              >Company Tin <span class="text-red-500">*</span></span
            >
            <vs-input
              name="CompanyTIN"
              type="number"
              v-validate="'required'"
              class="w-full"
              v-model="Company.companyTIN"
            />
            <span
              class="text-red-500 text-sm"
              v-show="errors.has('CompanyTIN')"
            >
              {{ errors.first("CompanyTIN") }}
            </span>
          </div>
          <div class="vx-col w-full mb-2">
            <span class="text-sm input-title"
              >Company Zip Code <span class="text-red-500">*</span></span
            >
            <vs-input
              name="CompanyZipCode"
              type="number"
              v-validate="'required'"
              class="w-full"
              v-model="Company.companyZipCode"
            />
            <span
              class="text-red-500 text-sm"
              v-show="errors.has('CompanyZipCode')"
            >
              {{ errors.first("CompanyZipCode") }}
            </span>
          </div>
          <div class="vx-row mb-3 ytd-container">
            <div class="vx-col ytd-column">
              <div class="input-wrapper">
                <!-- Add a wrapper with custom class -->
                <span class="input-title">CurrentYTDBasicPay</span>
                <!-- Title class -->
                <vs-input
                  name="CurrentYTDBasicPay"
                  type="number"
                  v-validate="'required'"
                  class="full-width-input"
                  v-model="Company.ytdBasicPay"
                />
              </div>
              <div class="input-wrapper">
                <span class="input-title">CurrentYTDGrossPay</span>
                <vs-input
                  name="CurrentYTDGrossPay"
                  type="number"
                  v-validate="'required'"
                  class="full-width-input"
                  v-model="Company.ytdGrossPay"
                />
              </div>
              <div class="input-wrapper">
                <span class="input-title">CurrentYTDWhtax</span>
                <vs-input
                  name="CurrentYTDWhtax"
                  type="number"
                  v-validate="'required'"
                  class="full-width-input"
                  v-model="Company.ytdwhTax"
                />
              </div>
              <div class="input-wrapper">
                <span class="input-title">CurrentYTDTaxableBonus</span>
                <vs-input
                  name="CurrentYTDTaxableBonus"
                  type="number"
                  v-validate="'required'"
                  class="full-width-input"
                  v-model="Company.ytdTaxableBonus"
                />
              </div>
              <div class="input-wrapper">
                <span class="input-title">CurrentYTDNonTaxableBonus</span>
                <vs-input
                  name="CurrentYTDNonTaxableBonus"
                  type="number"
                  v-validate="'required'"
                  class="full-width-input"
                  v-model="Company.ytdNonTaxableBonus"
                />
              </div>
              <div class="input-wrapper">
                <span class="input-title">CurrentYTDTaxableEarnings</span>
                <vs-input
                  name="CurrentYTDTaxableEarnings"
                  type="number"
                  v-validate="'required'"
                  class="full-width-input"
                  v-model="Company.ytdTaxableEarnings"
                />
              </div>
              <div class="input-wrapper">
                <span class="input-title">CurrentYTDNonTaxableEarnings</span>
                <vs-input
                  name="CurrentYTDNonTaxableEarnings"
                  type="number"
                  v-validate="'required'"
                  class="full-width-input"
                  v-model="Company.ytdNonTaxableEarnings"
                />
              </div>
              <div class="input-wrapper">
                <span class="input-title">CurrentYTDTaxablePremium</span>
                <vs-input
                  name="CurrentYTDTaxablePremium"
                  type="number"
                  v-validate="'required'"
                  class="full-width-input"
                  v-model="Company.ytdTaxablePremium"
                />
              </div>
              <div class="input-wrapper">
                <span class="input-title">CurrentYTDNonTaxablePremium</span>
                <vs-input
                  name="CurrentYTDNonTaxablePremium"
                  type="number"
                  v-validate="'required'"
                  class="full-width-input"
                  v-model="Company.ytdNonTaxablePremium"
                />
              </div>
            </div>
            <div class="vx-col ytd-column">
              <div class="input-wrapper">
                <span class="input-title">PreviousYTDBasicPay</span>
                <vs-input
                  name="PreviousYTDBasicPay"
                  type="number"
                  v-validate="'required'"
                  class="full-width-input"
                  v-model="Company.prevYTDBasicPay"
                />
              </div>
              <div class="input-wrapper">
                <span class="input-title">PreviousYTDGrossPay</span>
                <vs-input
                  name="PreviousYTDGrossPay"
                  type="number"
                  v-validate="'required'"
                  class="full-width-input"
                  v-model="Company.prevYTDGrossPay"
                />
              </div>
              <div class="input-wrapper">
                <span class="input-title">PreviousYTDWhtax</span>
                <vs-input
                  name="PreviousYTDWhtax"
                  type="number"
                  v-validate="'required'"
                  class="full-width-input"
                  v-model="Company.prevYTDWHTax"
                />
              </div>
              <div class="input-wrapper">
                <span class="input-title">PreviousYTDTaxableBonus</span>
                <vs-input
                  name="PreviousYTDTaxableBonus"
                  type="number"
                  v-validate="'required'"
                  class="full-width-input"
                  v-model="Company.prevYTDTaxableBonus"
                />
              </div>
              <div class="input-wrapper">
                <span class="input-title">PreviousYTDNonTaxableBonus</span>
                <vs-input
                  name="PreviousYTDNonTaxableBonus"
                  type="number"
                  v-validate="'required'"
                  class="full-width-input"
                  v-model="Company.prevYTDNonTaxableBonus"
                />
              </div>
              <div class="input-wrapper">
                <span class="input-title">PreviousYTDTaxableEarnings</span>
                <vs-input
                  name="PreviousYTDTaxableEarnings"
                  type="number"
                  v-validate="'required'"
                  class="full-width-input"
                  v-model="Company.prevYTDTaxableEarnings"
                />
              </div>
              <div class="input-wrapper">
                <span class="input-title">PreviousYTDNonTaxableEarnings</span>
                <vs-input
                  name="PreviousYTDNonTaxableEarnings"
                  type="number"
                  v-validate="'required'"
                  class="full-width-input"
                  v-model="Company.prevYTDNonTaxableEarnings"
                />
              </div>
              <div class="input-wrapper">
                <span class="input-title">PreviousYTDTaxablePremium</span>
                <vs-input
                  name="PreviousYTDTaxablePremium"
                  type="number"
                  v-validate="'required'"
                  class="full-width-input"
                  v-model="Company.prevYTDTaxablePremium"
                />
              </div>
              <div class="input-wrapper">
                <span class="input-title">PreviousYTDNonTaxablePremium</span>
                <vs-input
                  name="PreviousYTDNonTaxablePremium"
                  type="number"
                  v-validate="'required'"
                  class="full-width-input"
                  v-model="Company.prevYTDNonTaxablePremium"
                />
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </vs-prompt>
  </div>
</template>

<script>
import vSelect from "vue-select";
import Swal from "sweetalert2";

export default {
  components: {
    "v-select": vSelect,
  },

  data() {
    return {
      selected: {},
      selectedEmployee: null,
      selectedYearData: {},
      isEdit: false,
      activePromptAddRecord: false,

      Company: {
        id: 0,
        userId: "",
        yearScope: "",
        companyAddress: "",
        companyName: "",
        companyTIN: "",
        companyZipCode: "",
        prevYTDBasicPay: 0,
        prevYTDGrossPay: 0,
        prevYTDNonTaxableBonus: 0,
        prevYTDNonTaxableEarnings: 0,
        prevYTDNonTaxablePremium: 0,
        prevYTDTaxableBonus: 0,
        prevYTDTaxableEarnings: 0,
        prevYTDTaxablePremium: 0,
        prevYTDWHTax: 0,
        ytdBasicPay: 0,
        ytdGrossPay: 0,
        ytdNonTaxableBonus: 0,
        ytdNonTaxableEarnings: 0,
        ytdNonTaxablePremium: 0,
        ytdTaxableBonus: 0,
        ytdTaxableEarnings: 0,
        ytdTaxablePremium: 0,
        ytdwhTax: 0,
      },
    };
  },
  created() {
    this.$vs.loading();
    const payload = {
      pageNumber: 1,
      pageSize: -1,
    };
    this.$store
      .dispatch("hrms/getAllEmployee", payload)
      .then(() => {
        // this.employeeOptions = this.getAllEmployees();
        this.$vs.loading.close();
      })
      .catch((err) => {
        if (err.response.status === 404) {
          this.$vs.loading.close();
          return;
        }
        console.error(err);
      });
  },
  watch: {
    selected() {
      this.Company.userId = this.selected.id;
      console.log("Selected User ID:", this.Company.userId);
      this.handleUserSelection();
      this.fetchPrevCompanyData();
    },
  },

  methods: {
    promptAddNewRecord() {
      this.activePromptAddRecord = true;
    },

    onAddNewRecord() {
      // Extracting only the required parameters from Company
      const {
        userId,
        yearScope,
        companyAddress,
        companyName,
        companyTIN,
        companyZipCode,
        prevYTDBasicPay,
        prevYTDGrossPay,
        prevYTDNonTaxableBonus,
        prevYTDNonTaxableEarnings,
        prevYTDNonTaxablePremium,
        prevYTDTaxableBonus,
        prevYTDTaxableEarnings,
        prevYTDTaxablePremium,
        prevYTDWHTax,
        ytdBasicPay,
        ytdGrossPay,
        ytdNonTaxableBonus,
        ytdNonTaxableEarnings,
        ytdNonTaxablePremium,
        ytdTaxableBonus,
        ytdTaxableEarnings,
        ytdTaxablePremium,
        ytdwhTax,
      } = this.Company;

      // Creating a new object with the extracted parameters
      const companyDataToSend = {
        userId,
        yearScope,
        companyAddress,
        companyName,
        companyTIN,
        companyZipCode,
        prevYTDBasicPay,
        prevYTDGrossPay,
        prevYTDNonTaxableBonus,
        prevYTDNonTaxableEarnings,
        prevYTDNonTaxablePremium,
        prevYTDTaxableBonus,
        prevYTDTaxableEarnings,
        prevYTDTaxablePremium,
        prevYTDWHTax,
        ytdBasicPay,
        ytdGrossPay,
        ytdNonTaxableBonus,
        ytdNonTaxableEarnings,
        ytdNonTaxablePremium,
        ytdTaxableBonus,
        ytdTaxableEarnings,
        ytdTaxablePremium,
        ytdwhTax,
      };

      console.log("Data to be saved:", companyDataToSend);

      this.$vs.loading();
      this.$store
        .dispatch("hrms/addPreviousCompany", companyDataToSend)
        .then((response) => {
          this.$vs.loading.close();
          if (response.status == 200)
            this.$alert("", "Save Successfully", "success");
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$alert(error, "Error", "error");
        });
    },

    handleEmployeeSelection() {
      if (this.selectedEmployee) {
        this.Company.userId = this.selectedEmployee.id; // Assign selected employee's id to Company.userId
      } else {
        this.Company.userId = null; // Handle case where no employee is selected
      }
    },

    // this activates whenever a user selected an employee then call the getAllPrevCompany action
    fetchPrevCompanyData() {
      this.$store
        .dispatch("hrms/getAllPrevCompany", this.Company.userId)
        // .then((data) => {
        //   // console.log("Fetched Mello data:", data);
        // })
        .catch((err) => {
          console.log(err);
        });
    },

    clearDropdown() {
      const clearButton = document.querySelector(".vs__clear");
      if (clearButton) {
        clearButton.click();
        // console.log("Dropdown cleared");
      }
    },
    handleUserSelection() {
      this.selectedUserId = this.selected.id;
      // console.log("Selected User ID:", this.selectedUserId);
      this.clearDropdown();
      this.fetchPrevCompanyData();
    },
    SelectedYearandData() {
      const dataForSelectedYear = this.$store.getters[
        "hrms/getPrevCompanyInfoByYear"
      ](this.Company.yearScope);
      this.selectedYearData = dataForSelectedYear;
      // console.log(`Selected Year Data:`, this.selectedYearData); // Log the selected year data
    },
    editData() {
      if (!this.selectedYearData) {
        this.$alert("Please select the year", "YTD Processing", "error");
        return;
      }

      if (!this.Company.userId) {
        this.$alert("Please select an employee", "YTD Processing", "error");
        return;
      }
      this.isEdit = true;
      this.Company.id = this.selectedYearData.id;
      this.Company.companyName = this.selectedYearData.companyName;
      this.Company.companyAddress = this.selectedYearData.companyAddress;
      this.Company.companyTIN = this.selectedYearData.companyTIN;
      this.Company.companyZipCode = this.selectedYearData.companyZipCode;
      this.Company.ytdGrossPay = this.selectedYearData.ytdGrossPay;
      this.Company.ytdBasicPay = this.selectedYearData.ytdBasicPay;
      this.Company.ytdwhTax = this.selectedYearData.ytdwhTax;
      this.Company.ytdTaxableBonus = this.selectedYearData.ytdTaxableBonus;
      this.Company.ytdNonTaxableBonus =
        this.selectedYearData.ytdNonTaxableBonus;
      this.Company.ytdTaxableEarnings =
        this.selectedYearData.ytdTaxableEarnings;
      this.Company.ytdNonTaxableEarnings =
        this.selectedYearData.ytdNonTaxableEarnings;
      this.Company.ytdTaxablePremium = this.selectedYearData.ytdTaxablePremium;
      this.Company.ytdNonTaxablePremium =
        this.selectedYearData.ytdNonTaxablePremium;
      this.Company.prevYTDGrossPay = this.selectedYearData.prevYTDGrossPay;
      this.Company.prevYTDBasicPay = this.selectedYearData.prevYTDBasicPay;
      this.Company.prevYTDWHTax = this.selectedYearData.prevYTDWHTax;
      this.Company.prevYTDTaxableBonus =
        this.selectedYearData.prevYTDTaxableBonus;
      this.Company.prevYTDNonTaxableBonus =
        this.selectedYearData.prevYTDNonTaxableBonus;
      this.Company.prevYTDTaxableEarnings =
        this.selectedYearData.prevYTDTaxableEarnings;
      this.Company.prevYTDNonTaxableEarnings =
        this.selectedYearData.prevYTDNonTaxableEarnings;
      this.Company.prevYTDTaxablePremium =
        this.selectedYearData.prevYTDTaxablePremium;
      this.Company.prevYTDNonTaxablePremium =
        this.selectedYearData.prevYTDNonTaxablePremium;
    },

    saveData() {
      console.log("Data to be saved:", this.Company); // Log the data before loading

      this.$vs.loading();
      this.$store
        .dispatch("hrms/updatePreviousCompany", this.Company)
        .then((response) => {
          this.$vs.loading.close();
          if (response.status == 200) this.isEdit = false;
          this.$alert("", "Updated Successfully", "success");
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$alert(error, "Error", "error");
        });
    },

    cancelEdit() {
      this.isEdit = false;
    },

    confirmDeleteRecord(id) {
      if (!this.Company.userId) {
        this.$alert("Please select an employee", "YTD Processing", "error");
        return;
      }
      Swal.fire({
        title: "Are you sure you want to <strong>continue</strong>?",
        text: "",
        icon: "warning",
        customClass: {
          icon: "no-before-icon",
        },
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Confirm",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$vs.loading();
          this.$store
            .dispatch("hrms/deletePreviousCompany", id)
            .then((response) => {
              this.$vs.loading.close();
              if (response.status === 200) {
                this.$alert("", "Deleted Successfully", "success");
                this.clearDropdown();
              }
            })
            .catch((error) => {
              this.$vs.loading.close();
              this.$vs.notify({
                title: "Error",
                text: error.message || "Failed to delete record",
                color: "danger",
              });
            });
        } else {
          this.$vs.notify({
            title: "Cancelled",
            text: "Cancelled Delete",
            color: "warning",
          });
        }
      });
    },
  },

  computed: {
    getAllEmployees() {
      this.selectedUserId = this.selected.id;
      return this.$store.getters["hrms/getAllRealEmployees"]();
    },

    getPrevCompanyInfoByYear() {
      return this.$store.getters["hrms/getPrevCompanyInfoByYear"](
        this.Company.yearScope
      );
    },

    yearOptions() {
      const options = this.$store.getters["hrms/getUniqueYearScopes"];
      // console.log("Year options:", options); // Console log the year options
      return options;
    },

    validForm() {},
  },
};
</script>

<style scoped>
.vs-dialog {
  height: 90% !important;
  max-width: 700px !important;
  overflow: auto !important;
}

.header {
  text-align: center;
  margin-bottom: 20px;
}

.employer-card {
  width: 100%;
}

.field-group {
  margin: 20px;
}

.field {
  margin-bottom: 15px;
}

label {
  font-weight: bold;
  margin-bottom: 5px;
}

input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.compute-button {
  text-align: center;
  margin-top: 20px;
}

.year_div {
  padding-bottom: 2%;
}

.row-year {
  padding-left: 3%;
}

.no-data {
  text-align: center;
  padding: 10px;
}

.Company-table th,
.Company-table td {
  text-align: center;
  vertical-align: middle;
  padding: 10px 20px; /* Adjust padding as needed */
}

.Company-table .vs-input {
  width: 90%; /* Adjust width to spread out the inputs */
  margin: 0 auto; /* Center the inputs */
}
.employment-details-card .con-vs-dialog .vs-dialog {
  max-width: 600px !important;
}

.full-width-input {
  width: 100%;
}

.ytd-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.ytd-column {
  flex: 1;
  min-width: 315px;
  margin-left: 10px;
}

.ytd-title {
  font-weight: bold;
  margin-bottom: 10px;
}
.text-red-500 {
  color: red;
}

.input-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 4px; /* Adjust as needed */
}
</style>
